<template>
  <div class="rt-section">
    <div v-if="hasTitle" class="section-header">
      <div v-if="hasIcon" class="section-icon">
        <rt-icon :name="icon" :size="16" />
      </div>
      <span class="section-title">{{ title }}</span>
      <span v-if="showMore" class="section-more" @click="moreClick">更多</span>
      <div class="section-btns"><slot name="btn" /></div>
    </div>
    <div class="section-body"><slot /></div>
  </div>
</template>

<script>
export default {
  name: 'RtSection',
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    showMore: {
      type: Boolean,
      default: false
    },
    showlabel: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasIcon() {
      return !!this.icon;
    },
    hasTitle() {
      return !!this.title;
    }
  },
  methods: {
    moreClick() {
      this.$emit('more-click');
    }
  }
};
</script>

<style lang="less">
.rt-section {
  //   margin-top: 10px;
  padding: 10px;
  .section-header {
    display: flex;
    padding: 6px 10px 16px;
    align-items: center;
    .section-icon {
      background: #0099ff;
      color: #fff;
      border-radius: 2px;
      margin-right: 16px;
      height: 30px;
      width: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      .rt-icon {
        line-height: 1;
      }
    }
    span.section-title {
      color: #143e81;
      font-size: 16px;
      font-weight: 400;
    }
    .section-more {
      color: #a9c2e8;
      font-size: 14px;
      margin-left: 10px;
      cursor: pointer;
    }
    .section-btns {
      margin-left: auto;
    }
  }
  .section-body {
    padding: 0 10px 10px;
  }
}
</style>



// WEBPACK FOOTER //
// rtSection.vue?517b64f3